import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import updateLocale from 'dayjs/plugin/updateLocale'
import viLocale from 'dayjs/locale/vi'

dayjs.extend(relativeTime)
dayjs.extend(updateLocale)
dayjs.locale(viLocale)

dayjs.updateLocale('vi', {
    relativeTime: {
        future: 'trong %s',
        past: '%s trước',
        s: 'Vài giây',
        m: '1 phút',
        mm: '%d phút',
        h: '1 giờ',
        hh: '%d giờ',
        d: '1 ngày',
        dd: '%d ngày',
        M: '1 tháng',
        MM: '%d tháng',
        y: '1 năm',
        yy: '%d năm',
    },
})

/**
 * Generate a role name from display name
 * Converts "Project Manager" to "project_manager"
 */
export const generateRoleName = (displayName: string): string => {
    return displayName
        .trim()
        .toLowerCase()
        .replace(/[^\w\s-]/g, '') // remove non-alphanumeric except spaces and dash
        .replace(/\s+/g, '_')
}

export const getIconSrc = (fileFormat: string, mimeType?: string) => {
    const type = fileFormat?.toLowerCase()?.replace(/^\./, '')

    if (type === 'img') {
        if (mimeType === 'image/jpeg' || mimeType === 'image/jpg') {
            return '/svg/jpg-icon.svg'
        }
        if (mimeType === 'image/png') {
            return '/svg/png-icon.svg'
        }
    }

    const iconMap = {
        pdf: 'pdf-icon.svg',
        word: 'word-icon.svg',
        excel: 'excel-icon.svg',
        docx: 'word-icon.svg',
        doc: 'word-icon.svg',
        xlsx: 'excel-icon.svg',
        xls: 'excel-icon.svg',
        img: 'jpg-icon.svg',
        jpg: 'jpg-icon.svg',
        jpeg: 'jpg-icon.svg',
        png: 'png-icon.svg',
    }
    return `/svg/${iconMap[type as keyof typeof iconMap] || 'pdf-icon.svg'}`
}

export const getInitials = (name: string) => {
    return name.trim().charAt(0).toUpperCase()
}

export const generateTaskCode = () => {
    return `SV-${Date.now()}`
}

export const formatActivityTime = (date?: string | Date | null) => {
    if (!date) return ''
    const d = dayjs(date).locale('vi')
    const now = dayjs().locale('vi')
    const diffDays = now.diff(d, 'day')

    if (diffDays > 7) {
        return d.format('DD/MM/YYYY')
    }

    if (diffDays === 7) {
        return '1 tuần trước'
    }

    if (d.isAfter(now)) {
        return 'Vài giây trước'
    }

    const fromNow = d.fromNow()

    if (fromNow && fromNow.length > 0) {
        return fromNow.charAt(0).toUpperCase() + fromNow.slice(1)
    }

    return fromNow
}
